import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _01e60c7f = () => interopDefault(import('../src/pages/baggage-details/index.vue' /* webpackChunkName: "pages/baggage-details/index" */))
const _16cfac64 = () => interopDefault(import('../src/pages/booking-products/index.vue' /* webpackChunkName: "pages/booking-products/index" */))
const _06c935e4 = () => interopDefault(import('../src/pages/callback.vue' /* webpackChunkName: "pages/callback" */))
const _37e59075 = () => interopDefault(import('../src/pages/downloads/index.vue' /* webpackChunkName: "pages/downloads/index" */))
const _74f93348 = () => interopDefault(import('../src/pages/guests-details/index.vue' /* webpackChunkName: "pages/guests-details/index" */))
const _dc87a320 = () => interopDefault(import('../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _c12ac44c = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _0b807cfd = () => interopDefault(import('../src/pages/manage-booking/index.vue' /* webpackChunkName: "pages/manage-booking/index" */))
const _780d1191 = () => interopDefault(import('../src/pages/my-profile.vue' /* webpackChunkName: "pages/my-profile" */))
const _d2195486 = () => interopDefault(import('../src/pages/search-booking.vue' /* webpackChunkName: "pages/search-booking" */))
const _7babaeab = () => interopDefault(import('../src/pages/downloads/error.vue' /* webpackChunkName: "pages/downloads/error" */))
const _17700af9 = () => interopDefault(import('../src/pages/downloads/ticket.vue' /* webpackChunkName: "pages/downloads/ticket" */))
const _46d32ea6 = () => interopDefault(import('../src/pages/guests-details/questionnaire.vue' /* webpackChunkName: "pages/guests-details/questionnaire" */))
const _ad4221bc = () => interopDefault(import('../src/pages/manage-booking/cancel/index.vue' /* webpackChunkName: "pages/manage-booking/cancel/index" */))
const _1a2618ba = () => interopDefault(import('../src/pages/manage-booking/update-details.vue' /* webpackChunkName: "pages/manage-booking/update-details" */))
const _3576c788 = () => interopDefault(import('../src/pages/manage-booking/cancel/receipt.vue' /* webpackChunkName: "pages/manage-booking/cancel/receipt" */))
const _6fd6e94e = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/baggage-details",
    component: _01e60c7f,
    name: "baggage-details"
  }, {
    path: "/booking-products",
    component: _16cfac64,
    name: "booking-products"
  }, {
    path: "/callback",
    component: _06c935e4,
    name: "callback"
  }, {
    path: "/downloads",
    component: _37e59075,
    name: "downloads"
  }, {
    path: "/guests-details",
    component: _74f93348,
    name: "guests-details"
  }, {
    path: "/login",
    component: _dc87a320,
    name: "login"
  }, {
    path: "/maintenance",
    component: _c12ac44c,
    name: "maintenance"
  }, {
    path: "/manage-booking",
    component: _0b807cfd,
    name: "manage-booking"
  }, {
    path: "/my-profile",
    component: _780d1191,
    name: "my-profile"
  }, {
    path: "/search-booking",
    component: _d2195486,
    name: "search-booking"
  }, {
    path: "/downloads/error",
    component: _7babaeab,
    name: "downloads-error"
  }, {
    path: "/downloads/ticket",
    component: _17700af9,
    name: "downloads-ticket"
  }, {
    path: "/guests-details/questionnaire",
    component: _46d32ea6,
    name: "guests-details-questionnaire"
  }, {
    path: "/manage-booking/cancel",
    component: _ad4221bc,
    name: "manage-booking-cancel"
  }, {
    path: "/manage-booking/update-details",
    component: _1a2618ba,
    name: "manage-booking-update-details"
  }, {
    path: "/manage-booking/cancel/receipt",
    component: _3576c788,
    name: "manage-booking-cancel-receipt"
  }, {
    path: "/",
    component: _6fd6e94e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
